// Station catalog for Nexus Forge Phase 6.
//
// All station identity lives here. Adding a 3rd+ station = adding an
// entry to STATIONS; no DO class changes needed.

export type StationId = "station-7" | "station-12";

export type StationConfig = {
  readonly id: StationId;
  readonly displayName: string;
  readonly zoneId: string;
  readonly marketId: string;
  readonly npcCatalogId: string;
  readonly startingCoords: { readonly x: number; readonly y: number };
};

export const STATIONS: Readonly<Record<StationId, StationConfig>> = {
  "station-7": {
    id: "station-7",
    displayName: "Hub",
    zoneId: "station-7:hub",
    marketId: "station-7:market",
    npcCatalogId: "hub",
    startingCoords: { x: 100, y: 100 }, // contracts:allow-literal — level design spawn point
  },
  "station-12": {
    id: "station-12",
    displayName: "Frontier",
    zoneId: "station-12:hub",
    marketId: "station-12:market",
    npcCatalogId: "frontier",
    startingCoords: { x: 100, y: 100 }, // contracts:allow-literal — level design spawn point
  },
};

export const STATION_IDS: readonly StationId[] = ["station-7", "station-12"];

export const DEFAULT_STATION_ID: StationId = "station-7";

export function getStation(id: string): StationConfig | undefined {
  return STATIONS[id as StationId];
}

export function isValidStationId(id: string): id is StationId {
  return id in STATIONS;
}
